import fetch from '../config/fetch';
import fetchNew from '../config/fetchNew';

/**
 * 登录
 */
export const login = data => fetch('/web/employee/login', data, 'POST');

/**
 * 退出登录
 */
export const logOut = data => fetch('/platform/essEmployee/logOut', data, 'POST');

/**
 * 获取地域列表
 */
export const applicationAreaInfo = () => fetch('/platform/param/applicationAreaInfo', {}, 'GET');

/**
 * 根据id获取区域
 */
export const getRegionName = id => fetch(`/platform/s-provinces/getRegionName/${id}`, {}, 'GET');

/**
 * 获取委托商下拉列表
 */
export const customerInfoSelectList = data => fetch('/platform/sys/customerInfo/selectList', data, 'POST');
/**
 * 附件查询
 */
export const selectListBySourceId = id => fetch(`/platform/sys/attachment/selectListBySourceId/${id}`, {}, 'POST');

/**
 * 数据字典-相关类型
 */
// export const getParam = (id) => fetch( `/platform/paramCategoryAttr/getParam/${id}`, {}, 'GET')
export const getParam = data => fetch('/platform/paramCategoryAttr/selectCategoryAttr', data, 'GET');


// 个人信息
export const essEmployeeGetUserInfo = data => fetch('/platform/essEmployee/loginDetail', data, 'GET');
// 首页统计
export const homePageGetData = data => fetch('/platform/homePage/getData', data, 'GET');

// 修改密码
export const updatePassword = data => fetch(`/platform/essEmployee/updatePassword?${data}`, {}, 'POST');
// 默认修改密码
export const updatePasswordOne = data => fetch(`/platform/essEmployee/updatePasswordOne?${data}`, {}, 'POST');

/**
 * 委托商港口费用结算
 */
// 首页分页查询
export const settlementPageList = data => fetch('/platform/settlement/consignorPort/pageList', data, 'POST');
// 过驳费-资源车结算-分页查询
export const getPortResourceVehiclePageList = data => fetch('/platform/settlement/supplierPortOperation/resourceVehiclePageList', data, 'GET');
// 过驳费-资源车结算-刷新结算
export const refreshPortSupplierResourcesCar = data => fetch('/platform/settlement/supplierPortOperation/addSettlementPortResourceVehicle', data, 'POST');
// 水路-资源车-修改台账月
export const updatePortStandingBookMonth = data => fetch('/platform/settlement/supplierPortOperation/updateStandingBookMonth', data, 'POST');
/**
 * 供应商
 * 托运费用结算
 */
// 首页分页查询
export const supplierLinePageList = data => fetch('/platform/settlement/supplierLine/pageList', data, 'POST');
// 水路-资源车-分页查询
export const getResourceVehiclePageList = data => fetch('/platform/settlement/supplierLine/resourceVehiclePageList', data, 'GET');
// 水路-资源车-刷新结算
export const refreshSupplierResourcesCar = data => fetch('/platform/settlement/supplierLine/addSupplierResourcesCar', data, 'POST');
// 水路-资源车-修改台账月
export const updateStandingBookMonth = data => fetch('/platform/settlement/supplierLine/updateStandingBookMonth', data, 'POST');
// 补结算首页分页查询
export const supplierLinePage = data => fetch('/platform/settlement/supplierLine/add/pageList', data, 'POST');

/**
 * 供应商
 * 港口费用结算
 */
// 操作费分页查询
export const supplierPortOperationPageList = data => fetch('/platform/settlement/supplierPortOperation/pageList', data, 'POST');
// 操作费补结算分页查询
export const supplierPortOperationPage = data => fetch('/platform/settlement/supplierPortOperation/add/pageList', data, 'POST');
/**
 * 供应商
 * 提车费结算
 */
// 操作费分页查询
export const warehouseWarehousePage = data => fetch('/platform/settlement/warehouse/warehousePage', data, 'GET');
// 新增修改
export const warehouseAddWarehouse = data => fetch('/platform/settlement/warehouse/addWarehouse', data, 'POST');
/**
 * 供应商
 * 提车费结算
 */
// 分页
export const farePageList = data => fetch('/platform/settlement/supplierHandover/pageList', data, 'POST');
// 台账月修改
export const fareUpdateBatchStandingBookMonth = data => fetch('/platform/settlement/supplierHandover/updateBatchStandingBookMonth', data, 'POST');
// 刷新结算
export const fareRefreshSettlement = data => fetch(`/platform/settlement/supplierHandover/addSettlement?consignorName=${data.consignorName}`, {}, 'POST');
/**
 * 供应商
 * 海口
 * 加油搭费用结算
 */
// 分页查询
export const refuelingpowerList = data => fetch('/platform/settlement/supplierPortOther/pageList', data, 'GET');
// 燃油费审核->分页查询
export const auditPageList = data => fetch('/platform/settlement/supplierPortOther/auditPageList', data, 'GET');
// 分页子查询
export const refuelingpowerVehicleAllListById = data => fetch('/platform/settlement/refuelingpowerVehicle/allListById', data, 'GET');
// 根据公司id获取抵扣费用
export const deductionInvoicingCostGetAllByCompanyId = id => fetch('/platform/deductionInvoicingCost/choiceDeductionTicket', { 'companyId': id }, 'GET');
// 根据公司id获取其他费用
export const othercostGetAllByCompanyId = data => fetch('/platform/othercost/availablePageList', data, 'GET');
// 生成对账单
export const customerAdd = data => fetch('/platform/customer/account/add', data, 'POST');
// 结算管理—>供应商结算管理->港口费用结算->燃油费->新增弹出框->添加表格数据
export const addTableData = data => fetch('/platform/transportChild/getChildByFrameNumber', data, 'GET');
// 结算管理—>供应商结算管理->港口费用结算->燃油费->新增弹出框->详情
export const dialogInfo = id => fetch(`/platform/settlement/supplierPortOther/detailCost/${id}`, {}, 'GET');
// 结算管理—>供应商结算管理->港口费用结算->燃油费->新增弹出框->新增弹出框数据
export const addCost = data => fetch('/platform/settlement/supplierPortOther/addCost', data, 'POST');
// 结算管理—>供应商结算管理->港口费用结算->燃油费->新增弹出框->修改弹出框数据
export const updateCost = data => fetch('/platform/settlement/supplierPortOther/updateCost', data, 'POST');
// 结算管理—>供应商结算管理->港口费用结算->燃油费->删除
export const delCost = id => fetch(`/platform/settlement/supplierPortOther/delCost/${id}`, {}, 'POST');
// 结算管理—>供应商结算管理->港口费用结算->燃油费->修改台账月
export const updateStandingBook = data => fetch('/platform/settlement/supplierPortOther/updateBatchStandingBookMonth', data, 'POST');
// 结算管理->供应商结算管理->港口费用结算->燃油费->刷新结算
export const refreshSettlement = data => fetch('/platform/settlement/supplierPortOther/refreshSettlement', data, 'POST');
// 结算管理->供应商结算管理->港口费用结算->操作费->刷新结算
export const operationRefreshSettlement = id => fetch(`/platform/settlement/supplierPortOperation/addSettlementPort?type=${id}`, {}, 'POST');
// export const operationRefreshSettlement = data => fetch('/platform/settlement/supplierPortOperation/addSettlementPort', data, 'POST');
// 结算管理->供应商结算管理->港口费用结算->操作费->刷新补结算
export const operationAddRefreshSettlement = data => fetch('/platform/settlement/supplierPortOperation/add/addSettlementPort', data, 'POST');

// 堆存费->分页查询
export const storageList = data => fetch('/platform/finance/stockpile/pageList', data, 'POST');
// 堆存费->台账月修改
export const updateFinanceBatchStandingBookMonth = data => fetch('/platform/finance/stockpile/updateBatchStandingBookMonth', data, 'POST');
// 堆存费->刷新结算
export const stockpileRefreshSettlement = data => fetch('/platform/finance/stockpile/addSettlement', data, 'POST');
/**
 * 委托商对账单
 */
// 推送
export const dataPush = data => fetch(`/platform/price/consignorLine/push?id=${data.id}&reconciliator=${data.reconciliator}`, data, 'POST');
// 取消推送
export const cancellation = data => fetch('/platform/price/consignorLine/cancellation', data, 'POST');
// 对账单分页
export const accountList = data => fetch('/platform/customer/account/list', data, 'GET');
// 对账单-油价联动分页
export const oilPriceLinkageQuery = data => fetch('/platform/settlement/oilPrice/linkage/oilPriceLinkageQuery', data, 'POST');
export const oilPriceLinkQueryByRsi = data => fetch('/platform/settlement/oilPrice/linkage/oilPriceLinkQueryByRsi', data, 'GET');

// 对账单-油价联动添加
export const addOilPriceLinkage = data => fetch('/platform/settlement/oilPrice/linkage/addOilPriceLinkage', data, 'POST');
// 对账单-标题修改
export const changeTitle = data => fetch('/platform/customer/account/changeTitle', data, 'POST');
// 删除对账单
export const accountDelete = (id,reconciliator) => fetch(`/platform/customer/account/delete/${id}?${reconciliator}`, {}, 'POST');
// 对账单详情
export const accountDetail = id => fetch(`/platform/customer/account/detail/${id}`, {}, 'GET');

// 文件下载
export const download = id => fetch(`/web/attachmentFtp/download?attachmentId=${id}`, {}, 'POST');
// 结算管理->委托商结算管理->港口费用结算->修改台账月
export const updateBatchStandingBookMonth = data => fetch('/platform/settlement/consignorPort/updateBatchStandingBookMonth', data, 'POST');
// 结算管理->委托商结算管理->港口费用结算->修改台账月
export const operationUpdateBookMonth = data => fetch('/platform/settlement/supplierPortOperation/updateBatchStandingBookMonth', data, 'POST');

// 刷新结算港口费用结算
export const refreshSupplierwo = data => fetch('/platform/settlement/consignorPort/addSettlementConsignorPort', data, 'POST');

/**
 * 托运费用对账单获取详细信息
 * @param id
 * @returns {Promise<undefined|*>}
 * @constructor
 */
export const AccountDetail = id => fetch(`/platform/customer/account/detail/${id}`, {}, 'GET');
/**
 * 托运费用对账单获取结算费用
 * @param id
 * @returns {Promise<undefined|*>|*}
 * @constructor
 */
export const getPageListSCFI = obj => fetch(`/platform/customer/accountPrice/pageListSCFI?accountId=${obj.id}&page=${obj.page}&rows=${obj.rows}&type=${obj.type}`, {}, 'GET');

/**
 * 托运费用对账单获取其他结算费用
 * @param id
 * @returns {Promise<undefined|*>|*}
 * @constructor
 */
export const getPageListSOCI = obj => fetch(`/platform/customer/accountOther/pageListSOCI?accountId=${obj.id}&page=${obj.page}&rows=${obj.rows}`, {}, 'GET');
export const pageListSDLC = data => fetch('/platform/customer/account/pageListSDLC', data, 'GET');

export const pageListRA = data => fetch('/platform/customer/adjust/pageList', data, 'GET');

export const getSelectInvoice = data => fetch('/platform/finance/audit/selectInvoice', data, 'GET');

// 对账单获取开票信息
export const getInvoiceInfo = id => fetch(`/platform/customer/account/submitApprovalQuery/${id}`, {}, 'GET');
// 对账单发票新增
export const addInvoice = data => fetch('/platform/invoice/manage/add', data, 'POST');
// 对账单发票新增
export const updateInvoice = data => fetch('/platform/invoice/manage/updateInvoice', data, 'POST');
// 对账单发票详情
export const infoInvoice = id => fetch(`/platform/invoice/manage/detail/${id}`, {}, 'GET');
// 对账单发票删除
export const deleteInvoice = id => fetch(`/platform/invoice/manage/delete/${id}`, {}, 'POST');
// 对账单提交审核确定
export const submitAuditInvoice = data => fetch('/platform/customer/account/submitAudit', data, 'POST');
// 对账单新增获取服务名称
export const getServiceName = () => fetch('/platform/paramCategoryAttr/selectCategoryAttr?categoryCd=invoice_service_name', {}, 'GET');
// 对账单新增获取使用暂缓开票数据
export const getSelectData = (data) => fetch('/platform/customer/accountSusBill/getSelectData', data, 'GET');
// 对账单新增获取是否抵扣开票数据
export const getDeductIdOptions = (data) => fetch('/platform/deductionInvoicingCost/getSelectData', data, 'GET');
// 对账单新增获取是否超出合同价数据
export const getDeductionPriceId = (data) => fetch('/platform/customer/accountPriceDifference/getSelectData', data, 'GET');
// 对账单发票列表
export const getInvoiceList = id => fetch(`/platform/invoice/manage/invoiceManageList/${id}`, {}, 'GET');
//对账单新增获取单位信息(只有此处使用)
export const selectCategoryAttr = () => fetch('/platform/paramCategoryAttr/selectCategoryAttr?categoryCd=zd_1693191520523', {}, 'GET');
// 对账单审核列表
export const getStatementAuditList = data => fetch('/platform/customer/account/auditList', data, 'GET');
// 对账单复核/财务确认列表
export const getStatementAuditReexamineList = data => fetch('/platform/customer/account/reexamineList', data, 'GET');
// 财务确认
export const financialConfirmation = id => fetch(`/platform/customer/account/confirm/${id}`, {}, 'POST');
// 对账单审核详情
export const getStatementAuditInfo = id => fetch(`/platform/customer/account/auditDetail/${id}`, {}, 'GET');
// 对账单提交审核确定
export const postStatementAudit = data => fetch('/platform/customer/account/reviewSubmit', data, 'POST');
// 对账单提交复核确定
export const reexamineSubmit = data => fetch('/platform/customer/account/reexamineSubmit', data, 'POST');

// 对账单发票列表
export const getFinancePageList = data => fetch('/platform/customer/account/financePageList', data, 'GET');

// 对账单 核对对账单 通用 修改金额/删除
export const updateAndDeleteAmount = data => fetch('/platform/customer/account/updateAndDeleteAmount', data, 'POST');

// 对账单 核对对账单 通用 取消审核
export const cancelApplyFor = (id,reconciliator) => fetch(`/platform/customer/account/cancelApplyFor/${id}?${reconciliator}`, {}, 'POST');

// 对账单 核对对账单 通用 提交审核
export const submitAudit = data => fetch('/platform/customer/account/submitAudit', data, 'POST');

// 对账单  通用 退回
export const fallbackInvoice = data => fetch('/platform/invoice/manage/fallbackInvoice', data, 'POST');

// 核对对账单 其他费用核算 添加
export const addOther = data => fetch('/platform/customer/accountOther/add', data, 'POST');
// 核对对账单 其他费用核算 删除
export const delOther = data => fetch('/platform/customer/accountOther/delete', data, 'POST');
// 手工添加发票
export const addInvoiceManually = data => fetch('/platform/invoice/manage/manualAddInvoice', data, 'POST');
// 获取开票信息
export const getInfoInvoice = id => fetch(`/platform/invoice/manage/invoiceManageList/${id}`, {}, 'GET');
// 添加合同价
export const addContractPrice = data => fetch('/platform/customer/accountPriceDifference/addAndEdit', data, 'POST');


// 获取库房管理列表
export const getWarehouseList = data => fetch('/platform/warehouse/pageList', data, 'GET');

// 获取添加开票信息详情
export const getInvoicingList = data => fetch('/platform/invoice/manage/SupplementaryInvoiceDetail', data, 'POST');
// 获取添加开票信息详情
export const addInvoicing = data => fetch('/platform/invoice/manage/SupplementaryInvoiceAdd', data, 'POST');

// 寄送发票
export const sendInvoice = data => fetch('/platform/invoice/manage/sendInvoice', data, 'POST');
// 已收发票
export const receiveInvoice = (id,reconciliator) => fetch(`/platform/invoice/manage/receiveInvoice/${id}?reconciliator=${reconciliator}`, {}, 'POST');

// 缓存错误信息记录表
export const cahcacheDataPage = data => fetch('/platform/maintain/cahcacheDataPage', data, 'POST');
/**
 * 收入/支出台账与开票
 */
export const getLedgerPageList = data => fetch('/platform/ledger/invoice/getData', data, 'GET');
//收入台账与开票 刷新
export const autoFlashData = data => fetch('/platform/ledger/invoice/autoFlashData', data, 'GET');
//支出台账与开票 刷新
export const autoFlashData1 = data => fetch('/platform/ledger/invoice/autoFlashData1', data, 'GET');

/**
 * 收入分段统计表
 */
//查询
export const getSrfdPageList = data => fetch('/platform/statistical/report/getSrfdPage', data, 'GET');


//
export const documentAndInvoice = data => fetch('/platform/settlementStatement/settlementSchedule/documentAndInvoice', data, 'GET');

export const repeal = data => fetch(`/platform/reconciliation/repeal/${data.id}`, data, 'POST');

export const remarkSubmit = data => fetchNew('/customer/account/remarkSubmit', data, 'POST');

export const hongChong = data => fetchNew(`/customer/account/hongChong/${data.id}`, data, 'POST');

// export const hongChong = data => fetchNew(`/reconciliation/repeal/${data.id}`, data, 'POST');
